import type { YammerCache } from './types';

export default class MemoryStorage implements YammerCache {
  private items: Record<string, unknown>;

  constructor() {
    this.items = {};
  }

  public async getItem<T>(key: string): Promise<T | null> {
    return (this.items[key] as T) || null;
  }

  public async setItem<T>(key: string, value: T): Promise<void> {
    this.items[key] = value;
  }

  public async removeItem(key: string): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete this.items[key];
  }

  public async clear(): Promise<void> {
    this.items = {};
  }
}
